import {Component, OnInit, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-category-group',
  templateUrl: './category-group.component.html',
  styleUrls: ['./category-group.component.css']
})
export class CategoryGroupComponent implements OnInit, OnDestroy {
  show: boolean;
  dataset: any[];
  totalData: number;
  respObject: any;
  categories = [];
  groups = [];
  category: string;
  groupName: string;
  displayData: any;
  add = false;
  del = false;
  edit = false;
  view = false;
  isError = false;
  errorMessage: string;
  private notifier: NotifierService;
  private clientId: number;
  tickets = [];
  ticketSelected: number;
  type: string;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private userAuth: Subscription;
  offset: number;
  isCategory: boolean;
  dataLoaded:boolean;
  catSelected:any;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteMappingWithTicketAttrSuppGrp({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });
  }


  ngOnInit() {
    this.dataLoaded=false;
    this.isCategory = false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'View SupportGroup Category Map',
      openModalButton: 'Map SupportGroup with Category ',
      breadcrumb: 'SupportGroupCatMap',
      folderName: 'All SupportGroup Category Map',
      tabName: 'SupportGroup Category Map'
    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'group', name: 'Group ', field: 'groupname', sortable: true, filterable: true
      },
      {
        id: 'user', name: 'Category ', field: 'attrVal', sortable: true, filterable: true
      },
      {
        id: 'ttype', name: 'Ticket Type ', field: 'ticket_type', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
            this.tickets = this.respObject.details;
            this.ticketSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', JSON.stringify(err));
        });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }


  get groupSelected() {
        return this.groups
            .filter(opt => opt.checked)
            .map(opt => opt);
  }

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
        this.ticketSelected = 0;
        this.categories = [];
        // this.groupSelected = [];
        this.catSelected = 0;
        this.isCategory = false;
        this.groups = [];
        this._rest.getSupportGroupNotMapInCatagory(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.groups = this.respObject.details;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
      this.modalService.open(content).result.then((result) => {
      }, (reason) => {
      });
    }
  }

  save() {
      const supportGroup = [];
      for (let i = 0; i < this.groupSelected.length; i++) {
          supportGroup.push(this.groupSelected[i].id);

      }
    const data = {
      clientId: this.clientId,
      ticketAttrId: this.catSelected,
      supportGroupLevelId: supportGroup,
      createdBy: this.messageService.getUserId(),
      ticket_type: this.ticketSelected
    };
      // console.log('SSSSSSSSSSSSSSSSSSS====' + JSON.stringify(data));
    if (!this.messageService.isBlankField(data)  && this.groupSelected.length > 0) {
      this._rest.insertMappingWithTicketAttrSuppGrp(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
            this.isError = false;
            this.nextOffset = 0;
            this.page_no = 0;
            this.getTableData();
            this.ticketSelected = 0;
            this.categories = [];
            this.catSelected = 0;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getMappingWithTicketAttrSuppGrp(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }


  onTicketChange(selectedIndex: any) {
    this.type = this.tickets[selectedIndex].name;
    this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.respObject.details.unshift({id: 0, name: 'Select category'});
          this.isCategory = true;
        this.isError = false;
        this.categories = this.respObject.details;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }

}
